module.exports = __webpack_public_path__ + "chat.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/assets/img/chat.png
// module id = 2128
// module chunks = 13